import { Group, Stack, Text } from '@mantine/core';
import { UserAvatar } from 'components/UserAvatar';
import type { User } from 'shared/hooks/use-load-users';

type CollaboratorNameCellProps = {
  user: User;
};

export const CollaboratorNameCell = ({ user }: CollaboratorNameCellProps) => {
  return (
    <Group gap="xs" wrap="nowrap">
      <UserAvatar user={user} />
      <Stack gap={0}>
        <Text size="sm" fw={550} style={{ whiteSpace: 'nowrap' }}>
          {user.name.full}
        </Text>
        <Text size="sm" c="dimmed">
          {user.email}
        </Text>
      </Stack>
    </Group>
  );
};
